module.exports = __webpack_public_path__ + "static/media/5.a8d42e16.png";